import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// @mui
import { Box, Link } from '@mui/material';


const Logo = forwardRef(({ disabledLink = false, sx, ...other }: any, ref) => {
  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: "auto",
        height: 63,
        display: 'inline-flex',
        transform: 'scale(1.5)', // 🔹 adjust value as needed
        transformOrigin: 'center',
        ...sx,
      }}
      {...other}
    >
      <img
        alt=""
        src={`/assets/fortune8-logo.png`}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          pointerEvents: 'none',
        }} />
    </Box>
  );

  if (disabledLink) return <>{logo}</>;

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
